<template>
  <div class="admin__list">
    <div class="row mb-1 small text-muted">
      <div class="col-1 d-none d-md-block">Id</div>
      <slot name="headerList"></slot>
    </div>
    <loading v-if="loading" message="Загружаем ..."></loading>
    <div
      v-else
      v-for="item in items"
      :key="item.id"
      class="row mb-1 admin__list__item admin__list__item_hover-bg-gray">
      <div class="col-1 d-none d-md-block">
        {{item.id}}
      </div>
      <slot :item="item"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AdminList',
    props: {
      items: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminList.vue?7ec101b1